import { createRouter, createWebHistory } from 'vue-router'
import authService from '@/services/authService'

const routes = [
  // ── Public routes (no auth required) ──────────────────────────────
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPage.vue'),
    meta: { public: true }
  },
  // ── Authenticated routes ──────────────────────────────────────────
  {
    path: '/',
    name: 'list-projects',
    component: () => import('@/views/ListProjectsPage.vue')
  },
  {
    path: '/cadastrar-projeto',
    name: 'add-project',
    component: () => import('@/views/AddProjectPage.vue')
  },
  {
    path: '/editar-projeto',
    name: 'edit-project',
    component: () => import('@/views/EditProjectPage.vue')
  },
  {
    path: '/detalhes-projeto/:id',
    name: 'project-details',
    component: () => import('@/views/ProjectDetailsPage.vue')
  },
  {
    path: '/contexto-cliente',
    name: 'add-client-context',
    component: () => import('@/views/ClienteContextPage.vue')
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import('@/views/HomePage.vue')
  },
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/ChatPage.vue')
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () => import('@/views/ClientesPage.vue')
  },
  {
    path: '/processar-diario',
    name: 'diary-processing',
    component: () => import('@/views/DiaryProcessingPage.vue')
  },
  {
    path: '/diario-processado',
    name: 'diary-process-result',
    component: () => import('@/views/DiaryProcessResultPage.vue')
  },
  {
    path: '/modelo-diario',
    name: 'diary-model',
    component: () => import('@/views/DiaryModelPage.vue')
  },
  {
    path: '/projetos-diarios',
    name: 'projects-page',
    component: () => import('@/views/ProjectsPage.vue')
  },
  {
    path: '/listar-resultados',
    name: 'list-results',
    component: () => import('@/views/ListResults.vue')
  },
  {
    path: '/configurar-regras',
    name: 'rules-config',
    component: () => import('@/views/RulesConfigPage.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/DashboardPage.vue')
  },
  {
    path: '/projetos/:id/dashboard',
    name: 'project-dashboard',
    component: () => import('@/views/ProjectDashboard.vue')
  },

  // ── Admin routes ──────────────────────────────────────────────────
  {
    path: '/admin/upload-clients',
    name: 'UploadClientsPage',
    component: () => import('@/views/admin/UploadClientsPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/upload-diario',
    name: 'UploadDiarioPage',
    component: () => import('@/views/admin/UploadDiarioPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/enviar-email',
    name: 'AdminEmailPage',
    component: () => import('@/views/admin/AdminEmailPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/admin/parametros',
    name: 'ProcessingParamsPage',
    component: () => import('@/views/admin/ProcessingParamsPage.vue'),
    meta: { requiresAdmin: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// ── Global navigation guard ──────────────────────────────────────────
router.beforeEach(async (to, from, next) => {
  // 1. Public routes — always allowed
  if (to.meta.public) return next()

  // 2. Check authentication — use recently-verified cache for speed,
  //    otherwise hit the backend to ensure the cookie is still valid.
  let user = authService.getVerifiedCachedUser()
  if (!user) {
    user = await authService.getCurrentUser()
  }

  if (!user) {
    // Not authenticated → redirect to login, remembering where they wanted to go
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  // 3. Admin guard
  if (to.meta.requiresAdmin && user.is_admin !== true) {
    return next({ path: '/' })
  }

  return next()
})

export default router
